import jwt from 'jsonwebtoken';

export default {
    login: function ({ username, password }) {
        const request = new Request(process.env.REACT_APP_SERVER + '/auth', {
            method: 'POST',
            headers: new Headers({ 'Authorization': 'Basic ' + new Buffer(username + ':' + password).toString('base64') }),
        });

        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(({ token }) => {
                const decodedToken = jwt.decode(token);

                if (decodedToken.type === 'Owner') {
                    localStorage.setItem('name', decodedToken.name);
                    localStorage.setItem('rights', JSON.stringify(decodedToken.rights));
                    localStorage.setItem('token', token);
                } else {
                    return Promise.reject();
                }
            });
    },

    logout: function () {
        localStorage.removeItem('name');
        localStorage.removeItem('rights');
        localStorage.removeItem('token');

        return Promise.resolve();
    },

    checkAuth: function () {
        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
    },

    checkError: function ({ status }) {
        if (status === 401 || status === 403) {
            localStorage.removeItem('name');
            localStorage.removeItem('rights');
            localStorage.removeItem('token');

            return Promise.reject();
        }
        return Promise.resolve();
    },

    getPermissions: function () {
        const rights = localStorage.getItem('rights');
        return rights ? Promise.resolve(JSON.parse(rights)) : Promise.reject();
    }
};
